<template>
  <div class="home">
    <swiper :options="swiperOption" class="banner-box">
      <swiper-slide v-for="(item,index) in banner" :key="index">
        <!-- {{item}} -->
        <img :src="item" alt="">
      </swiper-slide>
    </swiper>

    <ul class="nav-box">
      <li v-for="(item,index) in navicon" :key="index">
        <router-link :to="item.link">
          <img :src="item.src" :alt="item.text">
          <p>{{item.text}}</p>
        </router-link>
      </li>
    </ul>
    <!-- <a href="http://www.xmf119.com/images/introduce.mp4" class="video-box">
      <img src="./../assets/img/home-video.jpg" alt="">
    </a> -->
    <!-- autoplay="autoplay"自动播放 -->
    <!-- <video res="videoBtn"  class="video-box" src="./../assets/img/introduce.mp4" controls="controls" poster="./../assets/img/home-video.jpg"></video> -->
    
    <video-player  
      class="video-player-box video-box"
      ref="videoPlayer"
      :options="playerOptions"
    />
    
    <div class="home-title">
      城市火灾风险大数据服务平台
    </div>
    <div class="img-box">
      <img src="./../assets/img/home-city-data.jpg" alt="">
    </div>
    <div class="home-title">
      服务价值
    </div>
    
    <ul class="server-box">
      <li v-for="(item,index) in server" :key="index">
        <img :src="item.src" alt="item.text">
        <p>{{item.title}}</p>
        <div class="bg-cont" v-html="item.infotext"></div>

        
      </li>
    </ul>
    

  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
// banner
import banner1 from "./../assets/img/banner_1.jpg";
import banner2 from "./../assets/img/banner_2.jpg";
import banner3 from "./../assets/img/banner_3.jpg";
import banner4 from "./../assets/img/banner_4.jpg";
import banner5 from "./../assets/img/banner_5.jpg";
// nav
import navicon1 from "./../assets/img/nav-icon_1.png";
import navicon2 from "./../assets/img/nav-icon_2.png";
import navicon3 from "./../assets/img/nav-icon_3.png";
import navicon4 from "./../assets/img/nav-icon_4.png";
import navicon5 from "./../assets/img/nav-icon_5.png";

import server1 from "./../assets/img/server_1.png";
import server2 from "./../assets/img/server_2.png";
import server3 from "./../assets/img/server_3.png";

import videosrc from './../assets/img/introduce.mp4';
import videoimg from './../assets/img/home-video.png';



import { swiper, swiperSlide } from "vue-awesome-swiper";

import 'video.js/dist/video-js.css';

import { videoPlayer } from 'vue-video-player';

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    videoPlayer
  },
  data() {
    return {
      playerOptions:{
        sources: [{
            type: "video/mp4",
            src: videosrc
          }],
          poster: videoimg,
      },
      swiperOption: {
        pagination: {
          el: ".swiper-pagination"
        },
        
        loop: true,
        autoplay: true
        // some swiper options...
      },
      banner: [banner1, banner2, banner3, banner4, banner5],
      navicon: [
        {
          src: navicon1,
          text: "公司介绍",
          link: "/about"
        },
        {
          src: navicon2,
          text: "新闻中心",
          link: "/news"
        },
        {
          src: navicon3,
          text: "解决方案",
          link: "/social"
        },
        {
          src: navicon4,
          text: "成功案例",
          link: "/cases"
        },
        {
          src: navicon5,
          text: "招商加盟",
          link: "/investment"
        }
      ],
      server:[
        {
          src:server1,
          infotext:'传递落实消防责任<br>避免刑事处罚<br>监督内部日常工作<br>提升管理效率',
          title:'社会单位'
        },
        {
          src:server2,
          infotext:'追溯中介机构工作过程<br>确定执法对象<br>掌握重点单位防火现状<br>提供政治依据',
          title:'消防监督部门'
        },
        {
          src:server3,
          infotext:'监督外场人员工作<br>创造更大利润<br>自动汇总项目报告<br>节省人工成本',
          title:'消防中介服务机构'
        }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.home {
  
  .nav-box{
    @extend .flex;
    li{
      flex:1;
      text-align: center;
    }
    a{
      display: block;
      padding-top:.4rem;
    }
    img{
      width:.9rem;
      
    }
    p{
      padding-top:.22rem;
      padding-bottom:.58rem;
      font-size: .26rem;
    }
  }
  .video-box{
   width:100%;
   .video-js{
     width:100%!important;
     height:3.5rem!important;
     .vjs-big-play-button{
       width:1.5em;
       height:1.5em;
       border-radius: 50%;
       left:50%;
       top:50%;
       transform: translate(-50%,-50%);
     }
   }
   
  }
  .home-title{
    font-weight: bold;
    line-height: 1rem;
    height: 1rem;;
    text-align: center;
  }
  .img-box{
    padding:0 .7rem;
    img{
      width:100%;
    }
  }
  .server-box{
    @extend .flex;
    padding:.2rem;
    li{
      text-align: center;
      margin-left:.1rem;
      position: relative;
      overflow: hidden;
      @extend .radius;
      color:#fff;
      &:first-child{
        margin:0;
      }
      img{
        width:100%;
        height: 2.85rem;
        display: block;
      }
      p{
         @include lineheight(0.9rem);
          background:$backBg;
          font-size: .24rem;
      }
      .bg-cont{
        position: absolute;
        left:0;
        top:0;
        @extend .bg;
        width:100%;
        height:2.85rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .2rem;
        line-height: .36rem;
      }
    }
  }
}
</style>
